import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { Table } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Pagination from "./Pagination"
import SpinningLoader from './SpinningLoader'
import { CSVLink } from 'react-csv'

type Props = {
  data?: any,
  loading?: boolean,
  pageNumber?: number,
  totalRecords?: number,
  limit?: number,
  setSearchResult?: (s: string) => void,
  setPageNumber?: (s: number) => void,
  setFilterData?: (s: string) => void,
  filterData?: string,
  searchData?: string,
  th1?: string,
  th2: string,
  th3: string,
  tableHeading: string,
  exportDisabled?: boolean,
  exportMrData?: any,
}

const TableView = ({ data, totalRecords = 0, loading, setFilterData = (s: string) => "", setSearchResult = (s: string) => "", limit = 8, pageNumber = 1, setPageNumber = (s: number) => 1, filterData, searchData, th1, th2, th3, tableHeading, exportDisabled, exportMrData }: Props) => {

  const [selectData, setSelectData] = useState<any[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    getZoneList()
  }, [])

  const getZoneList = () => {
    const getMRObj = {
      method: "get_zone_list",
    };
    fetch(`${process.env.REACT_APP_API_URL_MAIN}get_zone_list`, {
      method: "POST",
      headers: {},
      body: JSON.stringify(getMRObj),
    })
      .then((result) => {
        result.json().then((response) => {
          if (response.status === 1) {
            setSelectData(response?.data.sort((a: any, b: any) =>
              a.zone_name.localeCompare(b.zone_name)));
          }
        });
      })
  };

  const addZoneClick = () => {
    navigate("/add_zone")
  }

  const arr = exportMrData?.map((item: any, index: number) => {
    return (
      {
        "Id": index + 1,
        "MR Name": item?.mr_name,
        "Employee Id": item?.employee_id,
        "Zone Name": item?.zone_name,
        "Zone Id": item?.zone_id,
        "Submission Count": item?.submission_count,
      }
    )
  })

  return (
    <>
      <div style={{ position: 'relative', marginBottom: '10px', backgroundColor: "#FFFFFF", textAlign: 'left', borderRadius: '10px', boxShadow: '0px 0px 44px #D9EDEF', paddingLeft: '10px', paddingRight: '10px' }} >
        <div className='toolbar d-flex align-items-stretch justify-content-between p-5 '>
          <h3 style={{ color: '#5B5B5B', paddingTop: '10px' }} >{tableHeading}</h3>
          {/* begin::Toolbar container */}

          {((window.location.pathname !== "/admin/dashboard") && (window.location.pathname !== "/admin/data") && (window.location.pathname !== "/admin/mr_details")) &&
            <div className='d-flex align-items-stretch flex-wrap pt-3 pt-lg-0'>
              {/* ---------- search bar ------------- */}
              <div className='d-flex align-items-center'>
                <div className='d-flex align-items-center'>
                  <input className='search-input'
                    onChange={(e) => { setSearchResult(e?.target?.value); setPageNumber(1) }}
                    placeholder=' search '
                    style={{ outline: 'none', width: '200px', borderRadius: '8px', border: 'solid #F2F2F2 1px', fontSize: '16px', padding: '8px' }} />
                </div>
                <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
              </div>

              {/* -------- Add zone ---------- */}
              {window.location.pathname === '/admin/mr_list' && <div className='d-flex align-items-center'>
                <select
                  className='form-select-sm form-select-solid w-100px w-xxl-125px p-3'
                  defaultValue={filterData}
                  onChange={(e) => { setFilterData(e?.target?.value); setPageNumber(1); }}
                >
                  <option value='' hidden >Filter by zone</option>
                  <option value='' >All</option>
                  {
                    selectData?.map((item: any, index: number) => {
                      return (
                        <Fragment key={index}>
                          <option key={index} value={`${item?.id}`} >{item?.zone_name}</option>
                        </Fragment>
                      )
                    })
                  }
                </select>
              </div>}
              {/* ------------export Data------------- */}
              <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
              {window.location.pathname === '/admin/mr_list' && <div className='d-flex align-items-center'>
                {exportDisabled ? <CSVLink data={arr} filename={'mrlist'} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', height: 'max-content' }} >Export Data</CSVLink> : <div style={{ width: '108px', borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', height: 'max-content' }}> <SpinningLoader isLoading={!exportDisabled} /> </div>}
              </div>}

              {window.location.pathname === '/admin/zone_management' && <div className='d-flex align-items-center'>
                <button onClick={() => addZoneClick()} className='add-zone-btn' style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: 'max-content', height: 'max-content' }} >+ Add Zone</button>
              </div>}
            </div>}
        </div>
        {loading ?
          <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'black' }} >
            <SpinningLoader
              isLoading
            />
          </div>
          :
          data?.length !== 0 ?
            <>
              <Table style={{ borderBottom: '1px solid #F2F2F2', textAlign: 'left' }} responsive>
                <thead style={{ backgroundColor: '#F7F9FA', color: '#878CB9' }} >
                  <tr>
                    {th1 && <th>ID</th>}
                    {th1 && <th>{th1}</th>}
                    {th1 && <th>Employee ID</th>}
                    <th>{th2}</th>
                    <th>{th3}</th>
                  </tr>
                </thead>
                <tbody style={{ color: 'black' }} >
                  {
                    data?.map((item: any, index: number) => {
                      return (
                        <Fragment key={index}>
                          <tr>
                            {th1 && <td>{item?.id}</td>}
                            {th1 && <td>{item?.mr_name}</td>}
                            {th1 && <td>{item?.employee_id}</td>}
                            {th1 && <td>{item?.zone_name}</td>}
                            {th1 && <td>{item?.submission_count}</td>}
                            {!th1 && <td>{item?.zone_name}</td>}
                            {!th1 && <td>{item?.submission_count}</td>}
                          </tr>
                        </Fragment>)
                    })
                  }
                </tbody>
              </Table>
            </>
            : <div className='w-full text-center p-5' ><span style={{ margin: 'auto', textAlign: 'center', color: '#828BA5', fontSize: '1.5rem' }} >No Data Found</span></div>
        }
        {!loading && <div style={{ display: 'flex', paddingBottom: '0px', alignItems: 'center', justifyContent: 'center' }} >
          {window.location.pathname !== "/admin/dashboard" && <Pagination
            className="pagination-bar"
            currentPage={pageNumber}
            totalCount={totalRecords}
            pageSize={limit}
            onPageChange={(page: number) => setPageNumber(page)}
          />
          }
        </div>
        }
      </div>
    </>
  )
}

export default TableView


{/* <div style={{ display: 'flex', paddingBottom: '10px', alignItems: 'center', justifyContent: 'center' }} >
              {window.location.pathname !== "/admin/dashboard" && <div style={{ width: '40%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
                <button onClick={handlePrevBtn} disabled={pageNumber === 1} style={{ border: 'none', backgroundColor: 'transparent' }} >{(pageNumber === 1) ? <img src="./image/DLeftA.svg" alt="ra" /> : <img src="./image/right_arrow.svg" alt="ra" />}</button>
                <div className='align-center' >
                  <span style={{ fontSize: '15px', paddingRight: ' 5px', color: '#CECECE' }} >Page -</span>
                  <span style={{ fontSize: '15px' }} >
                    {pageNumber}
                  </span>
                </div>
                <button onClick={handleNextBtn} disabled={(data?.length <= 1) || (data?.length < limit)} style={{ border: 'none', backgroundColor: 'transparent' }} >{(data?.length <= 1) || (data?.length < limit) ? <img src="./image/DRightA.svg" alt="ra" /> : <img src="./image/left_arrow.svg" alt="ra" />}</button>
              </div>}
            </div> */}